import * as React from 'react'

// eslint-disable-next-line no-unused-vars
import { ISVG } from '../interfaces/svg'

export const EyeOff = ({ title, titleId, ...props }: ISVG) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M18.546 18.735a1 1 0 1 0-1.212-1.59l1.212 1.59ZM12 20v1h.016L12 20ZM1 12l-.881-.473a1 1 0 0 0-.013.92L1 12Zm5.667-5.145a1 1 0 0 0-1.214-1.59l1.214 1.59Zm3.005-3.589a1 1 0 0 0 .456 1.948l-.456-1.948ZM12 4l-.002 1H12V4Zm11 8 .882.471a1 1 0 0 0 .012-.918L23 12Zm-2.925 2.546a1 1 0 0 0 1.53 1.288l-1.53-1.288Zm-5.223.256a1 1 0 1 0-1.464-1.364l1.464 1.364Zm-4.29-4.19a1 1 0 1 0-1.364-1.464l1.364 1.464Zm6.772 6.533A9.07 9.07 0 0 1 11.984 19l.032 2a11.07 11.07 0 0 0 6.53-2.265l-1.212-1.59ZM12 19c-3.1 0-5.604-1.773-7.395-3.684a18.68 18.68 0 0 1-2.548-3.463 10.462 10.462 0 0 1-.156-.287l-.006-.012-.001-.002L1 12a128.571 128.571 0 0 0-.894.449.099.099 0 0 0 .005.009 7.254 7.254 0 0 0 .203.376 20.682 20.682 0 0 0 2.831 3.85C5.105 18.774 8.1 21 12 21v-2ZM1.881 12.473a17.45 17.45 0 0 1 4.786-5.618l-1.214-1.59A19.45 19.45 0 0 0 .12 11.527l1.762.946Zm8.247-7.26A8.12 8.12 0 0 1 11.998 5l.004-2a10.12 10.12 0 0 0-2.33.266l.456 1.948ZM12 5c3.1 0 5.605 1.774 7.395 3.684a18.676 18.676 0 0 1 2.548 3.463c.057.101.1.18.127.23l.029.057.006.012.001.002L23 12l.894-.448-.002-.003-.003-.007a8.989 8.989 0 0 1-.052-.1c-.035-.065-.085-.159-.151-.276a20.676 20.676 0 0 0-2.831-3.85C18.895 5.226 15.899 3 12 3v2Zm10.118 6.529a17.497 17.497 0 0 1-2.043 3.017l1.53 1.288a19.505 19.505 0 0 0 2.277-3.363l-1.764-.942Zm-8.73 1.91a2 2 0 0 1-1.958.574l-.495 1.938a4 4 0 0 0 3.917-1.15l-1.464-1.363Zm-1.958.574a2 2 0 0 1-1.443-1.443l-1.937.495a4 4 0 0 0 2.885 2.886l.495-1.938ZM9.987 12.57a2 2 0 0 1 .575-1.958L9.198 9.148a4 4 0 0 0-1.148 3.917l1.937-.495Z'
      fill='currentColor'
    />
    <path
      d='m1 1 22 22'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
